import type { SearchOrderTypesParams } from './order-type.api';

export const orderTypeKeys = {
  all: ['order-types'] as const,
  list: (params?: SearchOrderTypesParams): readonly unknown[] => [...orderTypeKeys.lists(), params] as const,
  lists: (): readonly string[] => [...orderTypeKeys.all, 'list'] as const,
};
